<template>
  <div ref="booking" class="vld-parent">
    <div :class="'alert alert-' + booking.room_slot.room.nickname">

      <div class="btn-group float-right">
        <button
          type="button"
          class="btn btn-sm btn-light-gray material-icons dropdown-toggle"
          data-toggle="dropdown"
          data-display="static"
          aria-haspopup="true"
          aria-expanded="false">
          settings
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            type="button"
            @click="addPlayers"
            disabled>
            <span class="material-icons mt-2">person_add</span>
            <span style="position:relative; bottom:4px;" class="ml-1">Add Players</span>
          </button>
          <button
            v-if="resceduleable"
            class="dropdown-item"
            type="button"
            @click="reschedule"
            disabled>
            <span class="material-icons mt-2">alarm_add</span>
            <span style="position:relative; bottom:4px;" class="ml-1">Reschedule Booking</span>
          </button>
          <button
            v-if="voucherable"
            class="dropdown-item"
            type="button"
            @click="voucher"
            disabled>
            <span class="material-icons mt-2">smart_display</span>
            <span style="position:relative; bottom:4px;" class="ml-1">Move to Voucher</span>
          </button>
          <button
            class="dropdown-item"
            type="button"
            @click="question">
            <a :href="faqRoute">
              <span class="material-icons mt-2">live_help</span>
              <span style="position:relative; bottom:4px;" class="ml-1">Questions?</span>
            </a>
          </button>
          <button
            class="dropdown-item"
            type="button"
            @click="contact">
            <a :href="contactRoute">
              <span class="material-icons mt-2">mail</span>
              <span style="position:relative; bottom:4px;" class="ml-1">Contact</span>
            </a>
          </button>
        </div>
      </div>

      <p class="mb-0"><span class="heading">Booked:</span> <b>{{ booking.room_slot.room.name }}</b> - {{ bookingDate }}</p>
      <p class="mb-0"><span class="heading">Players:</span>
        <span
          v-for="player in booking.players"
          style="position:relative; top:5px;"
          class="material-icons text-black">
          person
        </span>
      </p>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
    initialBooking: Object,
  },

  data() {
    return {
      booking: Object.assign({}, this.initialBooking),
    };
  },

  computed: {
    bookingDate() {
      return moment(this.booking.room_slot.start).format('ddd, Do MMM YYYY @ HH:mm')
    },

    resceduleable() {
      return moment(this.booking.room_slot.start).diff(moment(), 'days') > 7;
    },

    voucherable() {
      return moment(this.booking.room_slot.start).diff(moment(), 'days') > 7;
    },

    faqRoute() {
      switch (this.$deploymentCurrent) {
      case 'cryptology':
        return this.route('cryptology.faq');
      case 'breakescape':
        return this.route('breakescape.location.faq', this.location.slug);
      default:
        return this.route(this.$deploymentCurrent + '.faq');
      }
    },

    contactRoute() {
      return this.location.locationContactHref;
    },
  },

  watch: {

  },

  methods: {
    reschedule() {
      console.log('reschedule');
    },

    voucher() {
      console.log('voucher');
    },

    addPlayers() {
      console.log('addPlayers');
    },

    question() {
      console.log('question');
    },

    contact() {
      console.log('contact');
    },

  },
}
</script>
